import React from 'react';

import customTheme from 'app/style/theme';
import 'app/E2Book.css';

import { Box, Grommet, Heading } from 'grommet';
import AnimatedEllipsis from 'app/components/AnimatedEllipsis';

function Loading() {
  return (
    <Grommet className="App" full theme={customTheme}>
      <Box fill align="center" justify="center">
        <Heading>
          loading
          <AnimatedEllipsis small/>
        </Heading>
      </Box>
    </Grommet>
  );
}

export default Loading;



// WEBPACK FOOTER //
// ./src/app/components/Loading.js